import styled from "styled-components"

import {greys} from "@irati/ui/src/global/colors"
import Button, {IconTextButton} from "@irati/ui/src/Button"
import {Input, ValidationButton} from "@irati/ui/src/FormItem"

export const Wrapper = styled.div`
  padding: 0 15px;
`

export const QuestionWrapper = styled.div`
  background-color: white;
  box-shadow: 0 0 0 1px ${greys.mediumLight};
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  word-break: break-word;

  :first-child {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }

  :last-child {
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
`

export const IconButton = styled(IconTextButton)`
  margin-right: 10px;
  ${({disabled}) => disabled && `
    opacity: 0.7;
    cursor: not-allowed;
  `}
`

export const IconWrapper = styled.div`
  display: flex;
`
export const InputWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding-bottom: 10px;
  justify-content: space-between;
  align-items: center;

  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    flex-direction: row;
    align-items: flex-end;
  `}
`

export const Image = styled.img`
  margin: 0 5px;
  height: 20px;
`

export const StyledInput = styled(Input)`
  flex: 1;
  margin-bottom: 0;
  margin-left: -16px;

  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    max-width: 100%;
  `}
 `

export const ActionButton = styled(Button)`
  height: 40px;
  margin-top: 15px;

  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    margin-left: 10px;
    margin-top: 0;
    width: 80px;
`}
`

export const ValidationActionButton = styled(ValidationButton)`
  height: 40px;
  margin-top: 15px;
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    margin-left: 10px;
    margin-top: 0;
    width: 80px;
  `}
`

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 15px;
  width: 100%;

  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    flex-direction: row;
    width: auto;
  `}
`

export const DeleteWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 100%
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    flex-direction: row;
  `}
`
